const { VUE_APP_CHROME_EXTENSION_ID, VUE_APP_BETA_CHROME_EXTENSION_ID } = process.env;
export const EXTENSIONS_IDS = [VUE_APP_CHROME_EXTENSION_ID, VUE_APP_BETA_CHROME_EXTENSION_ID];

function chromeRuntimeSendMessage(extId, payload, callback) {
	/* eslint-disable no-undef */
	if (window.chrome && window.chrome.runtime) {
		window.chrome.runtime.sendMessage(extId, payload, (...args) => {
			if (window.chrome.runtime.lastError) {
				/**
				 * Probably will be Could not establish connection...
				 * for further reading: https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/API/runtime/lastError
				 */
				console.log(window.chrome.runtime.lastError);
			}
			callback?.(...args);
		});
		return true;
	}
	return false;
}

function sendToExtension(payload, callback) {
	return chromeRuntimeSendMessage(VUE_APP_CHROME_EXTENSION_ID, payload, callback);
}

function sendToSpecificExtension(extId, payload, callback) {
	return chromeRuntimeSendMessage(extId, payload, callback);
}

function sendToExtensions(payload, callback) {
	for (const extId of EXTENSIONS_IDS) {
		if (extId) {
			payload.ENV = process.env.VUE_APP_PLY_ENV;
			sendToSpecificExtension(extId, payload, callback);
		}
	}
}

const BrowserService = {
	chromeRuntimeSendMessage,
	sendToExtension, // To main
	sendToExtensions, // To all exts
	sendToSpecificExtension, // to a specific ext
};

export default BrowserService;
